import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MdsIconComponent } from '@medpacesoftwaredevelopment/designsystem';
import { ICellRendererParams } from '@medpacesoftwaredevelopment/designsystem/lib/components/ag-grid';
import { StudyExpenseTrackingDataRow } from '@models/studyExpenseTrackingDataRow';
import { BaseCellRendererComponent } from '../base-cell-renderer/base-cell-renderer.component';

@Component({
    selector: 'medpace-custom-cell-render-icon',
    imports: [MdsIconComponent],
    standalone: true,
    templateUrl: './custom-cell-render-icon.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCellRenderIconComponent<TContext = any> extends BaseCellRendererComponent<
    StudyExpenseTrackingDataRow,
    string,
    TContext,
    { icon: string }
> {
    refresh(
        params: ICellRendererParams<StudyExpenseTrackingDataRow, string, TContext> & {
            icon: string;
        }
    ): boolean {
        this.baseParams.set(params);
        this.customParams.set(params);
        return true;
    }
}
